import React, { useState } from 'react';
import ModalV2 from 'features/shared/ModalV2';
import FeedbackForm from './FeedbackForm';
import { FeedbackModalContent, FeedbackModalTitle, FeedbackFormScroll } from './FeedbackStyled';

type FeedbackModalProps = {
  onClose: () => void;
};

const FeedbackModal = ({ onClose }: FeedbackModalProps) => {
  const [isSuccess, setIsSuccess] = useState(false);

  return (
    <ModalV2 onClose={onClose} withoutPadding>
      <FeedbackModalContent $isSuccess={isSuccess} data-testid="feedback-modal">
        {!isSuccess && (
          <FeedbackModalTitle>Задайте вопрос или поделитесь предложением</FeedbackModalTitle>
        )}
        <FeedbackFormScroll $isSuccess={isSuccess}>
          <FeedbackForm onSuccessChange={setIsSuccess} />
        </FeedbackFormScroll>
      </FeedbackModalContent>
    </ModalV2>
  );
};

export default FeedbackModal;
